import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AppRoot from '../hubPage/HubPage';

function mapStateToProps(state) {
  return {
    ...state,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppRoot));
